import { useState, type FocusEvent, type PointerEvent } from "react";

interface ActiveMark<T> {
  datum: T;
  x: number;
  y: number;
}

export function useChartTooltip<T>() {
  const [active, setActive] = useState<ActiveMark<T> | null>(null);
  const hide = () => setActive(null);

  const markProps = (datum: T) => ({
    onPointerMove: (event: PointerEvent) =>
      setActive({ datum, x: event.clientX, y: event.clientY }),
    onPointerLeave: hide,
    onFocus: (event: FocusEvent) => {
      // A click focuses as well, and the pointer has then already placed the tooltip
      if (!event.currentTarget.matches(":focus-visible")) return;

      const rect = event.currentTarget.getBoundingClientRect();
      setActive({ datum, x: rect.left + rect.width / 2, y: rect.top });
    },
    onBlur: hide,
  });

  return { active, markProps };
}

export type ChartTooltipState<T> = ReturnType<typeof useChartTooltip<T>>;
